let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5ZMuJ"), load("c6MKV"), load("jjWia")]).then(() => parcelRequire('c8BWz'));